
export default {
  props: ['modelValue']
};
